import { binanceWallet } from '@pancakeswap/wagmi/connectors/binanceWallet'
import { http, createConfig } from 'wagmi'
import { JsonRpcProvider } from '@ethersproject/providers'
import memoize from 'lodash/memoize'
import { coinbaseWallet, injected, walletConnect, safe } from 'wagmi/connectors'
import { chains as CHAINS } from '@icecreamswap/constants'

const transports = Object.fromEntries(
  CHAINS.map((chain) => [chain.id, http(chain.rpcUrls.default.http[0])]),
)

export const injectedConnector = injected({ shimDisconnect: false })

export const coinbaseConnector = coinbaseWallet({
  appName: 'QomSwap',
  appLogoUrl: 'https://qomswap.io/logo.png',
})

export const walletConnectConnector = walletConnect({
  projectId: process.env.NEXT_PUBLIC_WALLETCONNECT_PROJECT_ID ?? '',
  showQrModal: true,
})

export const walletConnectNoQrCodeConnector = walletConnect({
  projectId: process.env.NEXT_PUBLIC_WALLETCONNECT_PROJECT_ID ?? '',
  showQrModal: false,
})

export const metaMaskConnector = injected({
  shimDisconnect: false,
  target: {
    id: 'metaMask',
    name: 'MetaMask',
    provider: () => {
      if (typeof window === 'undefined') return undefined
      const eth = (window as any).ethereum
      if (!eth) return undefined
      if (eth.isMetaMask && !eth.overrideIsMetaMask) return eth
      return eth.providers?.find((p: any) => p.isMetaMask && !p.overrideIsMetaMask) ?? (eth.isMetaMask ? eth : undefined)
    },
  },
})

export const bscConnector = binanceWallet()

function createInjectedConnector(id: string, getProvider: () => any) {
  return injected({
    shimDisconnect: false,
    target: { id, name: id, provider: getProvider },
  })
}

export const bitKeepConnector = createInjectedConnector('bitKeep', () => (window as any).bitkeep?.ethereum)
export const naboxConnector = createInjectedConnector('nabox', () => (window as any).ethereum)
export const okxConnector = createInjectedConnector('okx', () => (window as any).okxwallet)

export const chains = CHAINS

export const config = createConfig({
  chains: CHAINS as any,
  transports: transports as any,
  connectors: [
    safe(),
    metaMaskConnector,
    injectedConnector,
    coinbaseConnector,
    walletConnectConnector,
    bscConnector,
    bitKeepConnector,
    naboxConnector,
    okxConnector,
  ],
})

export const CHAIN_IDS = CHAINS.map((c) => c.id)

export const isChainSupported = memoize((chainId: number) => CHAIN_IDS.includes(chainId))
export const isChainTestnet = memoize((chainId: number) => CHAINS.find((c) => c.id === chainId)?.testnet)

export const getProvider = memoize(({ chainId }: { chainId?: number } = {}) => {
  const chain = CHAINS.find((c) => c.id === (chainId ?? CHAINS[0]?.id)) ?? CHAINS[0]
  const rpcUrl = chain?.rpcUrls.default.http[0]
  return new JsonRpcProvider(rpcUrl, chain?.id)
})
